export default __webpack_public_path__ + "static/media/logobranca.dfd80715.svg";